import { render, staticRenderFns } from "./ChangeDocRootModal.vue?vue&type=template&id=3e8b38d7&"
import script from "./ChangeDocRootModal.vue?vue&type=script&lang=js&"
export * from "./ChangeDocRootModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e8b38d7')) {
      api.createRecord('3e8b38d7', component.options)
    } else {
      api.reload('3e8b38d7', component.options)
    }
    module.hot.accept("./ChangeDocRootModal.vue?vue&type=template&id=3e8b38d7&", function () {
      api.rerender('3e8b38d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/ChangeDocRootModal.vue"
export default component.exports